export default {
      id: "watch-usage",
      viewBox: "0 0 11 11",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#watch-usage",
      toString: function () {
        return this.url;
      }
    }